module.exports = __webpack_public_path__ + "static/img/yhmrftx.fb8edbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yhmrftx.png
// module id = KX+K
// module chunks = 1